import React from "react";
import { Calendar, CalendarProps } from "react-calendar";
import styles from "./cp-calendar.module.css";
import { CpIcon } from "../cp-icon/cp-icon.component";

export type CpCalendarProps = CalendarProps & {};

export function CpCalendar(props: CpCalendarProps) {
  const { className, ...rest } = props;
  return (
    <Calendar
      {...rest}
      className={`${styles.reactCalendar} ${className || ""}`}
      calendarType="gregory"
      prevLabel={<CpIcon name="caret-large-left" />}
      nextLabel={<CpIcon name="caret-large-right" />}
      formatYear={(locale, date) => {
        return date.getFullYear().toString();
      }}
      formatMonth={(locale, date) => {
        return date.toLocaleDateString(locale, { month: "short" });
      }}
      prev2Label={null}
      next2Label={null}
      formatShortWeekday={(locale, date) => {
        const day = date.toLocaleDateString(locale, { weekday: "short" });
        return day.charAt(0).toUpperCase();
      }}
      showFixedNumberOfWeeks={true}
    />
  );
}
